import React, { useState, useEffect } from 'react';
import { getMigrationStatus, getPolicies } from '../mocks/api';

export default function MigrationStatus() {
  const [statuses, setStatuses] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');

  useEffect(() => {
    (async () => {
      const [s, p] = await Promise.all([getMigrationStatus(), getPolicies()]);
      setStatuses(s);
      setPolicies(p);
      setLoading(false);
    })();
  }, []);

  const getPolicyName = (id) => policies.find(p => p.id === id)?.name || 'Unknown';

  const filtered = statuses.filter(s => {
    if (filterStatus !== 'all' && s.status !== filterStatus) return false;
    if (filterType !== 'all' && s.entityType !== filterType) return false;
    return true;
  });

  const counts = {
    total: statuses.length,
    completed: statuses.filter(s => s.status === 'completed').length,
    failed: statuses.filter(s => s.status === 'failed').length,
    in_progress: statuses.filter(s => s.status === 'in_progress').length,
    pending: statuses.filter(s => s.status === 'pending').length,
  };

  if (loading) return <div className="loading">Loading migration status...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Migration Status</h2>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-number">{counts.total}</div>
          <div className="stat-label">Total</div>
        </div>
        <div className="stat-card stat-completed">
          <div className="stat-number">{counts.completed}</div>
          <div className="stat-label">Completed</div>
        </div>
        <div className="stat-card stat-in-progress">
          <div className="stat-number">{counts.in_progress}</div>
          <div className="stat-label">In Progress</div>
        </div>
        <div className="stat-card stat-failed">
          <div className="stat-number">{counts.failed}</div>
          <div className="stat-label">Failed</div>
        </div>
        <div className="stat-card stat-pending">
          <div className="stat-number">{counts.pending}</div>
          <div className="stat-label">Pending</div>
        </div>
      </div>

      <div className="card">
        <div className="filter-bar">
          <div className="form-group">
            <label>Status</label>
            <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
              <option value="all">All Statuses</option>
              <option value="completed">Completed</option>
              <option value="in_progress">In Progress</option>
              <option value="failed">Failed</option>
              <option value="pending">Pending</option>
            </select>
          </div>
          <div className="form-group">
            <label>Type</label>
            <select value={filterType} onChange={e => setFilterType(e.target.value)}>
              <option value="all">All Types</option>
              <option value="user">Users</option>
              <option value="application">Applications</option>
            </select>
          </div>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>Entity</th>
              <th>Type</th>
              <th>Policy</th>
              <th>Status</th>
              <th>Migrated At</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(s => (
              <tr key={s.id}>
                <td><strong>{s.entityName}</strong></td>
                <td><span className={`badge badge-type-${s.entityType}`}>{s.entityType}</span></td>
                <td>{getPolicyName(s.policyId)}</td>
                <td><span className={`badge badge-${s.status}`}>{s.status.replace('_', ' ')}</span></td>
                <td>{s.migratedAt || '-'}</td>
                <td className="details-cell">{s.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <p className="empty-state">No entries match the current filters.</p>}
      </div>
    </div>
  );
}
